/**
 * Return worst.test path if origin is piresroutes.test
 * @returns {string} origin path
 */

export const getUrl = () => {
    let origin = window.location.origin;

    return origin;
};
